<template>
    <div>
        <Breadcrumbs main="Products" title="Product offers"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">

              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                              
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <a class="btn btn-primary mr-3 mb-2"  v-b-modal.product >
                                
                                <i class="icon-shopping-car"> </i> Add Product Offer</a
                              >
                              <!-- <a hidden class="btn btn-outline-primary mr-3 mb-2" v-b-modal.request >
                                
                                <i class="icon-user"> </i> Patient Request</a
                              >
                              <a  class="btn btn-outline-primary mr-3 " v-b-modal.importPatient >
                                <i class="icon-cloud-up"> </i> Import </a
                              > -->
                              <!-- <b-form-group  label-cols="4" content-cols="4" :label="`Apply to (${selected.length})`" class="mb-0 datatable-select">
                                  <b-form-select @input="applyTo" style="width:100px" v-model="select" :options="selectOptions"></b-form-select>
                              </b-form-group> -->
                            </div>

                          </b-col>
                      </b-row>


                      <b-modal id="product" size="md" ref="productModal" title="Add Product Offer" ok-title="Done" class="theme-modal">
                                <template #modal-header>
                                    <h5>{{ editProduct ? 'Edit Product : '+editProduct : 'Add Product Offer' }} </h5>
                                    
                                </template>

                                <form id="productForm" @submit.stop.prevent="submitProduct" class="p-2 px-3">

                                    <figure v-if="productFile" class="b-image-wrapper image is-16by9 m-1">
                                        <b-img
                                            rounded
                                            :src="pro"
                                            style="width:100%"
                                            ratio="16by9"
                                        >
                                        </b-img>
                                    </figure>

                                    <div class="row form-group mt-2">
                                        <div class="col-sm-5 col-12">
                                            <label class="col-form-label" type="text" for="recipient-name">Product/Service: </label>
                                                <b-form-input 
                                                autocomplete="0"
                                                autofocus 
                                                required 
                                                v-model="product.product"
                                                placeholder=" Name">
                                            </b-form-input>
                                            
                                        </div>
                                        <div class="col-sm-3 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name"> Image: <span class="txt-primary"></span></label>
                                            <b-form-file accept="image/jpeg, image/png, , image/webp" v-model="productFile" ></b-form-file>
                                        </div>
                                        <div class="col-sm-4 col-4">
                                          <label class="col-form-label" for="recipient-name">Type: </label>
                                            <!-- <b-form-input 
                                            v-model="product.type" 
                                            placeholder="Type ">
                                            </b-form-input> -->
                                          <b-form-select required v-model="product.type" :options="productTypes"></b-form-select>
                                        </div>
                                    </div>
                                    <div class="row form-group mt-2">
                                        <div class="col-sm-6 col-6">
                                            <label class="col-form-label" type="text" for="recipient-name">Category: 
                                                <!-- <span class="badge badge-primary" @click="switchCategory"> swap </span> -->
                                            </label>
                                            <b-form-select v-if="categorySelect" required v-model="product.category" :options="getUser.categories"></b-form-select>
                                            <b-form-input 
                                                v-else
                                                v-model="product.category"
                                                placeholder="Category">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-6 col-6">
                                          <label class="col-form-label" for="recipient-name">Tags: </label>
                                          <b-form-input 
                                            v-model="product.tags" 
                                            placeholder="Tags ">
                                            </b-form-input>
                                        </div>
                                    </div>
                                    <div class="row form-group mt-2">
                                        <div class="col-sm-4 col-4">
                                            <label class="col-form-label" type="text" for="recipient-name">Price: <span class="txt-primary">{{ product.price && product.discount ? "("+ (product.price * ((100 - parseFloat(product.discount))/100)).toFixed(2)+")" : '' }} </span> </label>
                                            <b-form-input 
                                                type="number"
                                                required 
                                                step="0.01"
                                                v-model="product.price"
                                                placeholder="Price">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-4 col-4">
                                          <label class="col-form-label" for="recipient-name">Discount: </label>
                                          <b-form-input 
                                            required 
                                            type="number"
                                            step="0.0001"
                                            @input="checkDiscount"
                                            v-model="product.discount" 
                                            placeholder="Discount % ">
                                            </b-form-input>
                                        </div>
                                        <div class="col-sm-4 col-4">
                                          <label class="col-form-label" for="recipient-name">Offer Type: </label>
                                          <b-form-select required v-model="product.offerType" :options="offerTypes"></b-form-select> 
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                    <div class=" col-6">
                                      <label class="col-form-label" for="">Start Date</label>
                                      <b-form-datepicker
                                            :disabled="startDisabled"
                                            v-model="product.start" 
                                            placeholder="Start Date">
                                        </b-form-datepicker>
                                    </div>
                                    <div class=" col-6">
                                      <label class="col-form-label" for="">End Date</label>
                                      <b-form-datepicker
                                            :disabled="endDisabled"
                                            v-model="product.end" 
                                            placeholder="End Date">
                                        </b-form-datepicker>
                                      </div>
                                  </div>
                                  <div class="form-group row mt-2">
                                    <div class="col-sm-4 col-4">
                                        <label class="col-form-label" for="recipient-name">Exipry:</label>
                                        <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                        <b-form-radio-group required :options="statusOptions" v-model="expiry" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label" for="recipient-name">Visible:</label>
                                        <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                        <b-form-radio-group required :options="statusOptions" v-model="product.visible" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                      <div class="col-sm-4 col-4">
                                        <label class="col-form-label" for="recipient-name">Limited Edition:</label>
                                        <!-- <b-form-select required v-model="Shop.active" :options="statusOptions"></b-form-select> -->
                                        <b-form-radio-group required :options="statusOptions" v-model="product.limited" value-field="value" text-field="item">
                                        </b-form-radio-group>
                                      </div>
                                    <!-- <label class="col-form-label" type="text" for="recipient-name">Link:</label>
                                    <b-form-input v-model="alert.link" placeholder="Alert Link"></b-form-input> -->
                                  </div>
                                    <div class="form-group mt-2">
                                        <label class="col-form-label" for="recipient-name">Details: </label>
                                        <b-form-input 
                                            required 
                                            v-model="product.details" 
                                            placeholder="Details ">
                                        </b-form-input>
                                    </div>
                                    <div class="form-group ">
                                        <label class="col-form-label" for="">Description</label>
                                        <b-form-textarea
                                            id="textarea"
                                            v-model="product.description"
                                            placeholder="Enter description..."
                                            rows="3"
                                            max-rows="6"
                                        ></b-form-textarea>
                                        <br>
                                    </div>
                                    <b-button block  type="submit" variant="primary">Submit</b-button>
                                </form>
                            </b-modal>



                            <b-modal id="viewstats" ref="viewStatsModal" :title="'Product Offer Statistics : '+statsProduct.product" ok-title="Ok" class="theme-modal">
                              <b-table stacked :fields="statsfields" :items="[statsProduct.stats]">

                                <template #cell(impressions)="row">
                                    <span class="txt-primary"><b> {{ row.item.impressions }} views</b> </span> 
                                </template>

                                <template #cell(clicks)="row">
                                  <span class="txt-primary"><b> {{ row.item.clicks }} views </b></span>
                                </template>

                                <template #cell(ctr)="row">
                                  <span class="txt-primary"><b> {{ (row.item.clicks/row.item.impressions) * 100 }} %</b></span>
                                </template>

                                <template #cell(conversion)="row">
                                  <span class="txt-primary"><b> {{ row.item.conversion }} </b></span>
                                </template>

                              </b-table>
                            </b-modal>


                      <!-- view Shop -->
                            <b-modal id="viewproduct" ref="viewProductModal" :title="'View Shop : '+viewProduct.product" ok-title="Ok" class="theme-modal">
                              <b-table stacked :fields="viewProductfields" :items="[viewProduct]">

                                <template #cell(image)="row">
                                    <figure v-if="row.item.image" class="b-image-wrapper image is-16by9 m-1">
                                        <a :href="row.item.image" target="_blank">
                                            <b-img
                                                rounded
                                                :src="row.item.image"
                                                style="width:60%;"
                                            >
                                            </b-img>
                                        </a>
                                    </figure>
                                </template>

                                <template #cell(visible)="row">
                                    <a v-b-tooltip.hover @click="visible(row.item)" title="Click to change visible" :class="`btn ${ (row.item.visible ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.visible ? 'Yes' : 'No') }}
                                    </a>
                                </template>

                                <template #cell(offerType)="row">
                                  <div v-if="row.item.offerType" v-b-tooltip.hover  :class="`btn ${ (row.item.offerType == 'Discount' ? 'btn-primary' : row.item.offerType == 'Coupon' ? 'btn-warning text-dark' : row.item.offerType == 'Gift with Purchase' ? 'btn-info' : row.item.offerType == 'Promo' ? 'btn-danger' : 'btn-success') } btn-xs  mr-3`">
                                        {{ (row.item.offerType) }}
                                    </div>
                                </template>

                                <template #cell(expiry)="row">
                                    <a :class="`btn ${ (row.item.expiry ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.expiry ? 'Yes' : 'No') }}
                                    </a>
                                </template>

                                <template #cell(available)="row">
                                    <a v-b-tooltip.hover @click="available(row.item)" title="Click to change available" :class="`btn ${ (row.item.available ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.available ? 'Yes' : 'No') }}
                                    </a>
                                </template>

                                <template #cell(limited)="row">
                                    <a v-b-tooltip.hover @click="limited(row.item)" title="Click to change Limited Status" :class="`btn ${ (row.item.limited ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.limited ? 'Yes' : 'No') }}
                                    </a>
                                </template>

                                <template #cell(duration)="row">
                                  <span v-if="row.item.start" v-b-tooltip.hover class="txt-primary" > {{  new Date(row.item.start).toDateString().substring(4) }} </span> -
                                  <span v-if="row.item.end" v-b-tooltip.hover class="txt-primary" > {{  new Date(row.item.end).toDateString().substring(4) }} </span>
                                </template>

                                <template #cell(product)="row">
                                  <!-- <div class="txt-primary">
                                  {{ row.item.name }}
                                  </div> -->
                                    <span style="font-weight:500;" class="txt-primary">
                                        {{ row.item.product }} 
                                    </span>
                                </template>

                                <template #cell(price)="row">
                                  <!-- <div class="txt-primary">
                                  {{ row.item.name }}
                                  </div> -->
                                    <span :style="`font-weight:500;text-decoration:${row.item.discount !== 0 ? 'line-through' : ''}`" :class="row.item.discount == 0 ? 'txt-primary' : ''">
                                        {{ getUser.country.currency+parseFloat(row.item.price).toFixed(2) }} 
                                        
                                    </span>
                                    <span v-if="row.item.discount > 0" style="font-weight:500;" class="txt-primary">
                                            {{ getUser.country.currency+parseFloat((100  - row.item.discount)/100 * row.item.price).toFixed(2) }}
                                        </span>
                                </template>

                                <template #cell(discount)="row">
                                  <!-- <div class="txt-primary">
                                  {{ row.item.name }}
                                  </div> -->
                                    <span v-if="row.item.discount !== 0" style="font-weight:500;">
                                        {{ row.item.discount+"% off " }} 
                                        
                                    </span>
                                </template>

                                <template #cell(tags)="row">
                                    <div v-if="row.item.tags.length > 0">
                                        <a v-for="tag in row.item.tags" :key="tag" class="btn btn-primary btn-xs btn-pill mr-2">
                                            {{ tag }}
                                        </a>
                                    </div>
                                </template>

                                <template #cell(category)="row">
                                    <span class="btn btn-primary btn-xs" style="font-weight:500">
                                        {{ row.item.category }}
                                    </span>
                                </template>

                                <template #cell(createdAt)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                              </b-table>
                            </b-modal>

                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          :items="items"
                          :fields="tablefields"
                          :select-mode="selectMode"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          :filter="filter"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(action)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <!-- <b-dropdown-item @click="shops(row.item)">Shop Profiles</b-dropdown-item> -->
                              <b-dropdown-item @click="editproduct(row.item)">Edit</b-dropdown-item>
                              <!-- <b-dropdown-item @click="sms(row.item)">SMS</b-dropdown-item> -->
                              <b-dropdown-item @click="view(row.item)">View </b-dropdown-item>
                              <b-dropdown-item @click="stat(row.item)">Stats </b-dropdown-item>
                              <b-dropdown-item @click="del(row.item)">Delete </b-dropdown-item>
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="addcomment(row.item)">Add comment</b-dropdown-item> -->
                              <!-- <b-dropdown-item v-if="row.item.access[0].status" @click="viewcomment(row.item.fullname, row.item.tel)">View comment</b-dropdown-item> -->
                              <!-- <b-dropdown-divider></b-dropdown-divider> -->
                              <!-- <b-dropdown-item @click="del(row.index)">Delete </b-dropdown-item> -->
                          </b-dropdown>
                          </template>
        

                          <template #cell(active)="row">
                            <!-- <a :class="`btn ${ row.item.status (row.item.status == 'active' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`" @click="status(row.item.status)">
                                
                              {{ row.item.status }}  </a @click="status(row.item.access[0])"
                              > -->
                              <div v-b-tooltip.hover @click="status(row.item)" title="Click to change status" :class="`btn ${ (row.item.active ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                {{ (row.item.active ? 'Active' : 'Inactive') }}
                              </div>
                          </template>

                          <template #cell(image)="row">

                            <a :href="row.item.image" target="_blank">
                                            <b-img
                                                rounded
                                                :src="row.item.image"
                                                style="width:100px;height:100px;object-fit:cover"
                                            >
                                            </b-img>
                                        </a>
                        </template>
                    

                          <template #cell(product)="row">
                            <a @click="view(row.item)" class="txt-primary">
                               <b>{{ row.item.product }}</b>
                            </a>
                          </template>

                          <template #cell(type)="row">
                            <p class="txt-primary mb-1">
                              <b> {{ row.item.type }} </b>
                            </p>
                            <div v-if="row.item.offerType" v-b-tooltip.hover  :class="`btn ${ (row.item.offerType == 'Discount' ? 'btn-primary' : row.item.offerType == 'Coupon' ? 'btn-warning text-dark' : row.item.offerType == 'Gift with Purchase' ? 'btn-info' : row.item.offerType == 'Promo' ? 'btn-danger' : 'btn-success') } btn-xs  mr-3`">
                                        {{ (row.item.offerType) }}
                                    </div>
                          </template>

                          <template #cell(limited)="row">
                                    <a v-b-tooltip.hover @click="limited(row.item)" title="Click to change Limited Status" :class="`btn ${ (row.item.limited ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.limited ? 'Yes' : 'No') }}
                                    </a>
                                </template>

                          <template #cell(price)="row">
                              <p :style="`font-weight:500;text-decoration:${row.item.discount !== 0 ? 'line-through' : ''}`" :class="row.item.discount == 0 ? 'txt-primary mb-0' : ' mb-0'">
                                {{ getUser.country.currency+parseFloat(row.item.price).toFixed(2) }} 
                                        
                              </p>
                              <p v-if="row.item.discount > 0" style="font-weight:500;" class="txt-primary my-1">
                                  {{ getUser.country.currency+parseFloat((100  - row.item.discount)/100 * row.item.price).toFixed(2) }}
                              </p>
                              <p v-if="row.item.discount > 0" style="font-weight:500">{{ "- "+(row.item.discount).toFixed(2)+"% off" }} </p>
                            
                          </template>

                          <template #cell(duration)="row">
                                  
                            <p v-if="row.item.expiry">
                              <span v-if="row.item.start" v-b-tooltip.hover class="txt-primary" > {{  new Date(row.item.start).toDateString().substring(4) }} </span> -
                              <span v-if="row.item.end" v-b-tooltip.hover class="txt-primary" > {{  new Date(row.item.end).toDateString().substring(4) }} </span>
                            </p>
                            <p class="mb-0" style="font-weight:500">
                              Impressions: <span class="txt-primary">{{ row.item.impressions.length }}</span>
                            </p>
                            <p class="mb-0" style="font-weight:500">
                              Clicks: <span class="txt-primary">{{ row.item.clicks.length }}</span>
                            </p>
                                    
                            </template>

                           <template #cell(discount)="row">
                                  <!-- <div class="txt-primary">
                                  {{ row.item.name }}
                                  </div> -->
                                    <span v-if="row.item.discount !== 0" style="font-weight:500;">
                                        {{ row.item.discount+"% off - " }} 
                                        <span style="font-weight:500;" class="txt-primary">
                                            {{ getUser.country.currency+parseFloat((100 - row.item.discount)/100 * row.item.price).toFixed(2) }}
                                        </span>
                                    </span>
                            </template>

                          <template #cell(available)="row">
                                    <div v-b-tooltip.hover  @click="available(row.item)"  :class="`btn ${ (row.item.available ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                        {{ (row.item.available ? 'Yes' : 'No') }}
                                    </div>
                         </template>

                         <template #cell(visible)="row">
                                    <div v-b-tooltip.hover  @click="visible(row.item)" :class="`btn ${ (row.item.visible ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                        {{ (row.item.visible ? 'Yes' : 'No') }}
                                    </div>
                         </template>

                          <template #cell(date)="row">
                                <!-- {{ row.item.createdAt ? new Date(row.item.createdAt).toDateString().substr(4) : '' }} -->
                                {{ row.item.date }}
                          </template>
                        </b-table>
                        
                      </div>

                      <p>{{ items.length }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'
// import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  data(){
    return{
      singledropzoneOptions:{
          url:"http://localhost:8080/uploadpatient",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      startDisabled: true,
      endDisabled: true,
      requestLoading: false,
      submitting: false,
      categorySelect: true,
      typeSelect: true,
      codeData: {},
      shopTitle: '',
      editGroup: false,
      productFile: null,
      editProduct: null,
      group: {
        group: '',
        description: ''
      },
      viewProduct: {},
      statsProduct: {},
      pro: '',
      expiry: false,
      product: {
        product: '',
        category: null,
        tags: '',
        image: '',
        price: 0,
        discount: 0,
        offerType: null,
        start: null,
        end: null,
        expiry: false,
        visible: true,
        limited: false,
        type: 'Product',
        details: '',
        description: ''
      },
      productTypes: ['Product', 'Service'],
      offerTypes: ['Promo', 'Discount', 'Multibuy', 'Gift with Purchase', 'Coupon'],
      statusOptions: [
        //   { value: null, text: 'Select ' },
        { value: true, item: 'Yes' },
        { value: false, item: 'No' }
      ],
      tablefields: [
        { key: 'product', label: 'Product', sortable: true, },
        { key: 'image', label: 'Image', sortable: true, },
        { key: 'category', label: 'Category', sortable: true, },
        { key: 'type', label: 'Type', sortable: true, },
        { key: 'price', label: 'Price', sortable: true, },
        // { key: 'discount', label: 'Discount', sortable: true, },
        { key: 'duration', label: 'Duration', sortable: false, },
        { key: 'details', label: 'Details', sortable: false, },
        { key: 'available', label: 'Available', sortable: true, },
        { key: 'visible', label: 'Visible', sortable: true, },
        { key: 'limited', label: 'Limited', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      viewProductfields: [
        { key: 'image', label: 'Image', sortable: true, },
        { key: 'product', label: 'Product Name', sortable: true, },
        { key: 'category', label: 'Category', sortable: true, },
        { key: 'price', label: 'Price', sortable: true, },
        { key: 'discount', label: 'Discount', sortable: true, },
        { key: 'tags', label: 'Tags', sortable: true, },
        { key: 'type', label: 'Type', sortable: true, },
        { key: 'offerType', label: 'Offer Type', sortable: true, },
        { key: 'duration', label: 'Duration', sortable: true, },
        { key: 'expiry', label: 'Expiry', sortable: true, },
        { key: 'details', label: 'Details', sortable: true, },
        { key: 'description', label: 'description', sortable: true, },
        { key: 'available', label: 'Available', sortable: false, },
        { key: 'visible', label: 'Visible', sortable: true, },
        { key: 'limited', label: 'Limited Edition', sortable: true, },
        { key: 'createdAt', label: 'Date', sortable: true, },
      ],
      statsfields: [
        { key: 'impressions', label: 'Impressions', sortable: true, },
        { key: 'clicks', label: 'Clicks', sortable: true, },
        { key: 'ctr', label: 'CTR (Click Through Rate)', sortable: true, },
        { key: 'conversion', label: 'Conversion', sortable: true, },
      ],
      shopfields: [
        { key: 'shop', label: 'Shop', sortable: true, },
        { key: 'preferences', label: 'Preferences', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: false, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      items: [],
      allShops: [],
      allGroups: [],
      modes: ['multi', 'single', 'range'],
      filter: null,
      sortBy: 'createdAt',
      sortDesc: true,
      selectMode: 'multi',
      selected: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
      groupfields: [
        { key: 'group', label: 'Group', sortable: true, },
        // { key: 'type', label: 'Type', sortable: true, },
        // { key: 'description', label: 'Description', sortable: false, },
        { key: 'createdAt', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      sortGroupBy: 'product',
      currentGroupPage: 1,
      totalGroupRows: 1,
      perGroupPage: 5,
      totalShopRows: 1,
      perShopPage: 5,
      selectOptions: [
        'Group',
      ],
      select: null,
    }
  },
  components: {
    
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    userAdmin() {
      return localStorage.getItem('type') == "admin" ? true : false
    },
    getUser() {
      return this.$store.getters['authentication/getUser']
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
      },
      { immediate: true }

    )

  },
  watch: {
    dropFile() {
        if (this.dropFile !== null ){
            this.img = window.URL.createObjectURL(this.dropFile)    
        }

        if (this.dropFile == null) {
            window.URL.revokeObjectURL(this.img)
        }
    },
    productFile() {
        if (this.productFile !== null ){
            this.pro = window.URL.createObjectURL(this.productFile)    
        }

        if (this.productFile == null) {
            window.URL.revokeObjectURL(this.pro)
        }
    },
    expiry() {
      if (this.expiry) {
        //
        this.startDisabled = false
        this.endDisabled = false
        this.product.expiry = true
      } else {
        //
        this.startDisabled = true
        this.endDisabled = true
        this.product.expiry = false
      }
    }
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.items.length
  },
  methods: {
    fetchData() {

     const url = this.userAdmin ? '/products/' : '/products/'+this.getUser.name

      axios.get(url)
        .then(response=>{
          //
          this.items = response.data
          this.totalRows = this.items.length

          for (let index = 0; index < this.items.length; index++) {

                // date
                if (this.items[index].createdAt) {
                  this.items[index].date =  (new Date(this.items[index].createdAt)).toDateString().substring(4)
                
                }
            }
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text:e.response.data,
            type:'error'
          });
        })

        const ln = this.userAdmin ? '/groups/' : '/groups/'+this.getUser.name

        axios.get(ln).then( response=>{

            //
            this.allGroups = response.data
            this.totalGroupRows = response.data.length

            for (let index = 0; index < this.allGroups.length; index++) {

                // date
                if (this.allGroups[index]) {
                  this.allGroups[index].text = this.allGroups[index].group
                  this.allGroups[index].value = this.allGroups[index].group
                }
            }

        }).catch(error=>{

            console.log(error.response.data)
        })

        // axios.get('/vendor')
        // .then(response=>{
        //   //
        //   //   this.items = response.data
        //   const vendors = response.data.map(vendor => vendor.business)
        //   this.vendorOptions = []
        //   //   this.vendorOptions  = [...new Set(vendors)]
        // //   const vendorList = []
          
        //   for (let index = 0; index < vendors.length; index++) {
        //     const value = { code: vendors[index], name: vendors[index] };
        //     this.vendorOptions.push(value)
        //   }
        //   console.log(this.vendorOptions)
          
        // })
        // .catch( e => {
        //   this.$swal({
        //     title:"Failed!",
        //     text:e.response.data,
        //     type:'error'
        //   });
        // })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    shops(data) {
        // modal
        this.$refs.shopModal.show()
        //
        this.shopTitle = data.name

        //
        // axios.get('/order/'+data.business).then( response=>{
            let _shop = this.getUser.name

            //
            this.allShops = this.userAdmin ? data.shops : data.shops.filter(shop => shop.shop == _shop)
            this.totalShopRows= this.userAdmin ? data.shops.length : data.shops.filter(shop => shop.shop == _shop).length

        // }).catch(error=>{

        //     console.log(error.response.data)
        // })

    },
    submitProduct() {

        //
        // this.product.name = this.viewProduct
        // validate
        // if (this.allProducts.find(pro => pro.product.includes(this.product.product))) {
        //   return
        // }
        //
          delete(this.product.imageFile)
          this.product.price = parseFloat(this.product.price)
          this.product.discount = parseFloat(this.product.discount)
          this.product.tags = this.product.tags
          this.product.shop = this.getUser.name

          console.log(this.product.image)
          //
          let url
          let method

          if (this.editProduct) {
            url = '/product/'+encodeURIComponent(this.editProduct)
            method = axios.patch;

          } else {
            url = '/product'
            method = axios.post;

          }
          //
          method(url, this.product).then(response =>{
            //
            this.$swal({
              title:"Good job!",
              text: response.data,
              type:'success'
            });
            //
            // this.products(this.getUser.name)
            this.fetchData()

          }).catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.response.data,
                type:'error'
              });
          })


        if (this.productFile) {
            
            //
            const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload'
            //
            const formData = new FormData()
            formData.append('upload_preset', 'qwwhqvhe')
            formData.append('folder', 'shopnscan/products/')
            // set
            formData.append('file', this.productFile)
            //
            fetch(cloudURL, {
                method: 'POST',
                body: formData
            }).then(async response=> {
                        
            const data = await response.json()

            if (!response.ok) {
                const error = (data && data.message) || response.status

                this.$swal({
                    title:"Failed!",
                    text: data.message,
                    type:'error'
                });

                return Promise.reject(error)
            }

            // this.product.image = data.secure_url

            axios.patch('/product/image/'+encodeURIComponent(this.product.product), { image: data.secure_url, shop: this.getUser.name }).then(() =>{
                //
                // this.$swal({
                //   title:"Good job!",
                //   text: response.data,
                //   type:'success'
                // });
                //
                // this.products(this.getUser.name)
                this.fetchData()

            }).catch( e => {
                this.$swal({
                    title:"Failed!",
                    text: e.response.data,
                    type:'error'
                });
            })

            })
        }  
                
            // });
        // }
    },
    submitProducts() {
        //
        const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload'
        //
        if (this.products.length > 0) {
            this.products.forEach( product => {
                //
                const formData = new FormData()
                formData.append('upload_preset', 'qwwhqvhe')
                formData.append('folder', 'shopnscan/products/')
                // set
                formData.append('file', product.imageFile)
                //
                fetch(cloudURL, {
                    method: 'POST',
                    body: formData
                }).then(async response=> {
                    
                    const data = await response.json()

                    if (!response.ok) {
                        const error = (data && data.message) || response.status
                        return Promise.reject(error)
                    }

                    //
                    product.image = data.secure_url
                    delete(product.imageFile)

                    console.log(product.image)
                    
                })
                
            });
        }
    },
    editproduct(data){

    this.$refs.productModal.show()

      this.editProduct = data.product
      //
      const product = {}
      product.shop = data.shop
      product.product = data.product
      product.category = data.category
      product.image = data.image
      product.tags = data.tags
      product.price = data.price
      product.discount = data.discount
      product.type = data.type
      product.start = data.start
      product.end = data.end
      product.visible = data.visible
      product.expiry = data.expiry
      product.limited = data.limited
      product.offerType = data.offerType
      product.details = data.details
      product.description = data.description

      this.product.shop = product.shop
      this.product.product = product.product
      this.product.category = product.category
      this.product.image = product.image
      this.product.tags = product.tags.join(',')
      this.product.price = product.price
      this.product.discount = product.discount
      this.product.type = product.type
      this.product.start = product.start
      this.product.end = product.end
      this.product.visible = product.visible
      this.product.expiry = product.expiry
      this.expiry = product.expiry
      this.product.limited = product.limited
      this.product.offerType = product.offerType
      this.product.details = product.details
      this.product.description = product.description
      
      //
      
    },
    view(data){
      // modal
      this.$refs.viewProductModal.show()

      this.viewProduct = data
      //
    },
    stat(data) {
      // modal
      this.$refs.viewStatsModal.show()

      this.statsProduct = data
    },
    visible(data) {
      //
      axios.post('/product/visible', { shop: data.shop, product: data.product, status: data.visible })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    available(data) {
      //
      axios.post('/product/available', { shop: data.shop, product: data.product, status: data.available })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    limited(data) {
      //
      axios.post('/product/limited', { shop: data.shop, product: data.product, status: data.limited })
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
    },
    del(data) {
      this.$swal({
        title: "Delete '"+data.product+"'?",
        text: "Are you sure, You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {

          //
          axios.delete(`/product/${data.shop}/${encodeURIComponent(data.product)}`)
          .then(response=>{
            //
            this.$swal({
              title:`Deleted '${data.product}'!`,
              text: response.data,
              type: 'success'
            })
            // delete image from cloud
            

            //
            this.fetchData()
          })
          .catch( e => {
            this.$swal({
              title:"Failed!",
              text: e.response.data,
              type:'error'
            });
          })
          
        }
      })

    },
    onSelect({name, iso2, dialCode}) {
        // this.form.code = "+"+dialCode
        this.vendor.country.name = name.split("(")[0].trim()
        this.vendor.country.currency = dialCode == "233" ? iso2+"₵" : iso2
        this.vendor.country.code = "+"+dialCode
        this.vendor.phone.countryCode = "+"+dialCode
        console.log(name, iso2, dialCode);
    },
    switchCategory() {
        this.categorySelect = this.categorySelect ? false : true
    },
    switchType() {
        this.typeSelect = this.typeSelect ? false : true
    },
    applyTo() {
        //
        this.$refs.groupModal.show()
    },
    calculateAge(dob) { 
      //
      let now
      now = moment(new Date())
      const _dob = moment(dob)
      return now.diff(_dob, 'years')
    },
    checkDiscount() {
      this.product.offerType = this.product.discount > 0 ? 'Discount' : null
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}

.loader-box [class*="loader-"] {
    width: 30px;
    height: 30px;
}
</style>